<template>
  <div class="menu-wrapper bg-white">
      <div class="container h-full">
            <ul class="flex items-center h-full float-left">
                    <li @click="closeMenu()">
                        <router-link to="/monitor/web" class="text-dark-blue">WEB N.V. (758)</router-link>
                    </li>
                    <li @click="closeMenu()">
                        <router-link to="/monitor/astec" class="text-dark-blue">ASTEC N.V. (716)</router-link>
                    </li>
                    <li @click="closeMenu()" v-if="hasWEBAccess">
                        <router-link to="/monitor/web-only"  class="text-dark-blue">WEB N.V. (726) </router-link>
                    </li>
                    <li @click="closeMenu()">
                        <a @click.prevent="logout()" href="#" class="text-dark-blue">Log out</a>
                    </li>
            </ul>
            <div class="float-right h-full close-menu-x">
                <a @click.prevent="closeMenu()" href="#" class="text-dark-blue">&#10005;</a>
            </div>
      </div>
  </div>
</template>

<script>
export default {
    computed: {
        hasWEBAccess() {
            if(this.$store.state.userData && this.$store.state.userData.roles.includes('aqi_monitor_web'))
                return true;
            else
                return false
        }
    },
    methods: {
        logout() {
            this.$store.commit('LOGOUT');
            this.$router.push({name: 'Login'});
        },
        closeMenu() {
            this.$store.commit('SET_MENU_OPEN', false);
        }
    }

}
</script>

<style lang="scss">
.menu-wrapper {
    position: absolute;
    width: 100%;
    left: 0;
    right:0;
    top: 0;
    z-index: 9999;
    box-shadow: 0 2px 4px rgba(1,1,1,.3);
    height: 80px;
    .container {
        max-width: 1920px;
        padding: 0 40px;
        li{
            a{
                padding: 10px 20px;
                //background: blue;
                //margin-right: 10px;
                //margin-left: 5px;
                border-right: 1px solid lightgrey;
            }
        }
        .close-menu-x {
            padding-top: 15px;
            font-size: 2rem;
            
        }
    }
}

// sm
@media (max-width: 767.98px) { 
.menu-wrapper {
    height:auto;
        .container {
            padding: 0 20px;
            ul{
                flex-direction: column;
                li{
                    a{
                        display: block;
                        padding: 20px 20px;
                        //background: blue;
                        //margin-right: 10px;
                        //margin-left: 5px;
                        text-align: left;
                        border-bottom: 1px solid lightgrey;
                        border-right: none;
                    }
                }
                .close-menu-x {
                    padding-top: 15px;
                    font-size: 2rem;
                    
                }
            }
        }
    }
}

</style>